import { classNames } from "primereact/utils"
import InputFrame from "./InputFrame"
import { Password } from "primereact/password"

export default function InputPasswordForm(props) {

    const field = props.controller.field
    const fieldState = props.controller.fieldState

    const handleOnBlur = (e) => {
        if (props?.clearString) {
            const cleanedValue = e.target.value.replace(/\s\s+/g, ' ').trim()
            if (cleanedValue !== e.target.value) {
                field.onChange(cleanedValue)
            }
        }
        if (props?.noSpace) {
            const cleanedValue = e.target.value.replace(/ /g, '').trim()
            if (cleanedValue !== e.target.value) {
                field.onChange(cleanedValue)
            }
        }
        if (field.onBlur) field.onBlur(e)
        if (props.onBlur) props.onBlur(e)
    }
    return (
        <>
            <InputFrame {...props}>

                <Password
                    id={field.name}
                    feedback={false}
                    toggleMask={true}
                    {...field}
                    autoComplete={props.autoComplete || "off"}
                    onBlur={handleOnBlur}
                    className={'p-inputtext-sm ' + (fieldState.isDirty ? '' : '') + classNames({ 'p-invalid': fieldState.error })}
                    inputMode={props.inputMode}
                    pattern={props.pattern}
                    onKeyDown={props.onKeyDown}
                    autoSave={false}
                />

            </InputFrame>
        </>
    )
}
